import { useState } from "react";

import { makeGetApiCall, makePostApiCall } from "../../../shared/makeApiCall";
import { useToast } from "../../../contexts/ToastContext";
import UserDetailsForm from "../../../components/forms/user/UserDetailsForm";

export function UsersViewModel(logout) {
  const { showSuccess } = useToast();
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState({
    data: [],
  });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const user_id = localStorage.getItem("id") * 1;

  const getUsers = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`users`, payload);
    setLoading(false);
    if (callResult.success) {
      const mappedUsers = callResult.data.data.map((user) => {
        var typeText = user.type === 0 ? "Sales Rep" : "Administrator";
        user.typeText = typeText;
        return user;
      });
      setUsers({ ...callResult.data, data: mappedUsers });
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const createUser = async function (values) {
    const payload = { ...values, user_id: user_id };
    let callResult = await makePostApiCall("createUser", payload);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getUsers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const updateUser = async function (user, values, index) {
    let callResult = await makePostApiCall(`users/${user.id}`, values);

    if (callResult.success) {
      showSuccess(
        callResult.data.message || "Action completed"
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getUsers("", 1);
      }, 1000);
    } else {
      if (callResult.errorStatus === 401) {
        logout();
      }
    }
  };

  const openAddUserSlideOver = () => {
    setSlideOver({
      childComponent: (
        <UserDetailsForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createUser}
        />
      ),
      open: true,
    });
  };

  const viewUserDetails = async function (user, index) {
    setSlideOver({
      childComponent: (
        <UserDetailsForm
          user={user}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateUser}
        />
      ),
      open: true,
    });
  };

  return {
    openAddUserSlideOver,
    getUsers,
    loading,
    users,
    setSlideOver,
    slideOver,
    viewUserDetails,
  };
}
